module.exports = __webpack_public_path__ + "img/u88.1a00bfa3.png";